import { render, staticRenderFns } from "./DisciplinasGradesContent.vue?vue&type=template&id=75ed1d42&"
import script from "./DisciplinasGradesContent.vue?vue&type=script&lang=js&"
export * from "./DisciplinasGradesContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports